import { AfterViewInit, EventEmitter, Component, Input, Output } from '@angular/core';
import { AddressModel } from '../../../../shared/models/address.model';
import { PaymentService } from '../../../services/payment.service';
import { PaymentPaymentOption } from '../payment.payment.option';

@Component({
    selector: 'payment-payment-option-payment-on-shipping',
    templateUrl: './payment.payment.option.payment-on-shipping.component.html',
    styleUrls: ['../../../payment.component.scss']
})
export class PaymentPaymentOptionPaymentOnShippingComponent extends PaymentPaymentOption implements AfterViewInit {
    public filledFlag = false;
    public extraFieldsState = true;
    private extraFieldsData: Object;
    @Input() index;
    @Input() deliverable: boolean;
    @Output() filled: EventEmitter<null> = new EventEmitter();

    constructor(
        protected paymentService: PaymentService
    ) {
        super();
    }

    ngAfterViewInit() {
        if (this.deliverable) {
            this.ready();
        }
    }

    /**
     * Set extraFieldsState property when changed
     * */
    public onExtraFieldsChange(isValid: boolean): void {
        this.extraFieldsState = isValid;
    }

    /**
     * Sets extra fields object to be sent for request
     * */
    public setExtraFieldsData(data: Object): void {
        this.extraFieldsData = data;
    }
    /**
     * Billing address filled event listener.
     **/
    public onFilled(address: AddressModel): void {
        this.paymentService.setBillingAddress(address);
        this.ready();
    }
    /**
     * Option ready to be paid after selected.
     **/
    private ready() {
        this.filledFlag = true;
        this.filled.emit(null);
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src2078029388/src/src/app/payment/payment/option/payment-on-shipping/payment.payment.option.payment-on-shipping.component.ts